import { GETCURRENCY_SUCCESS, GETCURRENCY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getCurrencyReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETCURRENCY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETCURRENCY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getCurrencyReducer;
